import { render, staticRenderFns } from "./vdMenu.vue?vue&type=template&id=523b0e4b&scoped=true&"
import script from "./vdMenu.vue?vue&type=script&lang=js&"
export * from "./vdMenu.vue?vue&type=script&lang=js&"
import style0 from "./vdMenu.vue?vue&type=style&index=0&id=523b0e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../hastrid-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b0e4b",
  null
  
)

export default component.exports